<template>
    <div class="sub-sidebar" :data-open="state === 'open' ? 1 : 0">
        <div
            ref="card"
            class="relative bottom-sheet-card bg-base-100 shadow-xl m-auto absolute w-full sm:left-24 sm:w-96"
            :data-state="isMove ? 'move' : state"
            :style="{ top: `${isMove ? calcY() + (y - this.startY) : calcY()}px` }"
            @touchstart="getTouchScreen"
            @touchend="getTouchScreen"
        >
            <div class="absolute pan-area w-full" ref="pan" :class="{ 'half-pan': state === 'half' || state === 'open-scroll' }"
                @click="handleClick"
            >
                <div class="bar bg-base-300" ref="bar"></div>
            </div>
            <div class="contents">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

  <script>
import Hammer from 'hammerjs';

export default {
    props: {
        defaultState: {
            type: String,
            default: 'close'
        },
        isShowLocationDetail: {
            type: Boolean,
            default: false
        },
        listSearchBox: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            mc: null,
            y: 0,
            startY: 0,
            isMove: false,
            state: this.defaultState,
            rect: {},
            halfY: window.innerWidth >= 768 ? 0.6 : 0.6,
            touchstartX: 0,
            touchstartY: 0,
        };
    },
    mounted() {
        window.onresize = () => {
            this.rect = this.$refs.card.getBoundingClientRect();
        };
        this.rect = this.$refs.card.getBoundingClientRect();

        this.mc = new Hammer(this.$refs.pan);
        this.mc.get('pan').set({ direction: Hammer.DIRECTION_ALL });

        this.mc.on('panup pandown', (evt) => {
            this.y = evt.center.y - 16;
        });

        this.mc.on('panstart', (evt) => {
            this.startY = evt.center.y;
            this.isMove = true;
        });

        this.mc.on('panend', (evt) => {
            this.isMove = false;

            switch (this.state) {
                case 'half':
                    if (this.startY - evt.center.y > 120) {
                        this.state = 'open';
                    }

                    if (this.startY - evt.center.y < -50) {
                        this.state = 'close';
                    }
                    break;
                case 'open':
                    if (this.startY - evt.center.y < -120) {
                        this.state = 'half';
                    }
                    break;
                case 'open-scroll':
                    if (this.startY - evt.center.y > 1) {
                        this.state = 'open';
                    }
                    if (this.startY - evt.center.y < -1) {
                        this.state = 'open';
                    }
                    if (this.startY - evt.center.y < -120) {
                        this.state = 'open';
                    }
                    if (this.startY - evt.center.y < -50) {
                        this.state = 'half';
                    }
                    break;
            }
        });
    },
    beforeDestroy() {
        this.mc.destroy();
        window.onresize = null;
    },
    methods: {
        calcY() {
            switch (this.state) {
                case 'close':
                    return this.rect.height;
                case 'open':
                    return this.rect.height * 0.04;
                case 'half':
                    return this.rect.height * this.halfY;
                case 'open-scroll':
                    return this.rect.height * 0.04;
                default:
                    return this.y;
            }
        },
        setState(state) {
            this.state = state;
        },
        getTouchScreen(evt) {
            const elem = evt.target.closest('.overflow-y-auto');
            if (evt.type == 'touchstart') {
                this.touchstartX = evt.changedTouches[0].screenX;
                this.touchstartY = evt.changedTouches[0].screenY;
            }
            if (evt.type == 'touchend') {
                var touchendX = evt.changedTouches[0].screenX;
                var touchendY = evt.changedTouches[0].screenY;
                this.checkScrolling(elem, this.touchstartX, this.touchstartY, touchendX, touchendY);
            if (this.state === 'open-scroll') {
                setTimeout(() => {
                    this.state = this.previousState;
                }, 1500);            }
            }
        },
        checkScrolling(elem, touchstartX, touchstartY, touchendX, touchendY) {
            var pageWidth = window.innerWidth || document.body.clientWidth;
            var treshold = Math.max(1,Math.floor(0.01 * (pageWidth)));
            var limit = Math.tan(45 * 1.5 / 180 * Math.PI);

            var x = touchendX - touchstartX;
            var y = touchendY - touchstartY;
            var xy = Math.abs(x / y);
            var yx = Math.abs(y / x);

            if (Math.abs(x) > treshold || Math.abs(y) > treshold) {
                if (xy <= limit) {
                    if (y >= 0) {
                        if ($(elem).scrollTop() == 0) {
                            this.state = 'open-scroll';
                        }
                    }
                }
            }
            if (this.state !== 'open-scroll') {
                this.previousState = this.state;
            }
        },
        handleClick() {
            if (this.state === 'half') {
                this.setState('open');
            }
        },
    },
    watch: {
        defaultState(newVal) {
            if (this.isMobileScreen && newVal == 'open') {
                return this.state = this.isShowLocationDetail ? 'open' : 'half';
            }
            this.state = newVal;
        },
        state(newVal) {
            this.$emit('changedState', newVal);
            if (!this.isShowLocationDetail || newVal != 'close') {
                return;
            }

            this.$emit('closedLocationDetail');
        }
    },
    computed: {
        isMobileScreen() {
            return window.screen.width <= 640;
        }
    }
};
</script>

 <style lang="scss" scoped>
.sub-sidebar[data-open='1'] {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
}

@media (max-width: 640px) {
    .sub-sidebar[data-open='1'] .bg {
        display: block;
        transition: all;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.3);
        background-attachment: fixed;
    }
}

.bottom-sheet-card {
    height: 100vh;
    position: fixed;
    border-radius: 10px 10px 0 0;
    box-shadow: 0 -3px 4px rgba(0, 0, 0, 0.1);
    z-index: 100;
}

.bottom-sheet-card[data-state='half'],
.bottom-sheet-card[data-state='open'],
.bottom-sheet-card[data-state='close'] {
    transition: top 0.18s ease-out;
}

.bottom-sheet-card[data-state='close'] {
    box-shadow: none;
}

.bar {
    width: 110px;
    height: 8px;
    border-radius: 14px;
    margin: 0 auto;
    cursor: pointer;
}

.pan-area {
    padding: 15px;
    padding-bottom: 15px;
}
.half-pan{
    height: inherit;
    z-index: 50;
  }

.contents {
    overflow-y: scroll;
    max-height: 100%;
    padding-bottom: calc(100vh * 0.2);
    box-sizing: border-box;
}
</style>
